import React from 'react';
import { withRouter } from 'react-router-dom';

import Construct from '../Construct/Construct';

import './mainLayoutFullScreen.less';

const MainLayoutConstruction = () => {
  return (
    <>
      <Construct />
    </>
  );
};

export default MainLayoutConstruction;
